import { useEffect, useState } from "react";
import Papa from "papaparse";
import { item } from "./types";
import DrinksListItem from "./DrinksListItem";
import { Accordion } from "react-bootstrap";

type props = {
  items: item[];
};

const DynamicDrinksList = (props: props) => {
  
  return (
    <div style={{display: "flex", flexWrap: "wrap"}}>
      {
        props.items.map((cask, i) => {
          return <DrinksListItem drink={cask} key={i} />;
        })
      }
    </div>
  );
};

export default DynamicDrinksList;
